// @core/api/endpoints/booking/update_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookableResourceResponse,
  UpdateResourceRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Update bookable resource
 * Updates name, description, pricing, capacity, status, or other resource fields.
 */
export async function UpdateResource(
  resource_id: string,
  data: UpdateResourceRequest,
  options?: RequestOptions
): Promise<BookableResourceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.put<BookableResourceResponse>(requestPath, data, requestOptions);
}
